export const myAccountHeaderText = {
  signInHeader: 'Sign in',
  registerHeader: 'Register for My Account',
};
